<seds-form-field-core
  [label]="label"
  [iconName]="iconName"
  [iconPosition]="iconPosition.LEFT"
  [warningColor]="warningColor"
  [sendedControl]="_control"
  [type]="type"
  [selectFieldIcon]="iconFieldStatus">
  <div *ngIf="controlName; then reactivef; else templated"></div>

  <ng-template #reactivef>
    <div *ngIf="isMultiple; then multipleChoose; else singleChoose"></div>

    <ng-template #singleChoose>
      <mat-select
        disableRipple
        [formControl]="formControl"
        [panelClass]="customStyle"
        tabIndex="0"
        disableOptionCentering
        [attr.disabled]="disabled"
        (openedChange)="openChangeStatus($event)">
        <mat-option
          [ngClass]="currentCheckboxColor"
          class="dropdown-custom"
          *ngFor="let option of optionList"
          [value]="option.key"
          [attr.aria-label]="option.value"
          >{{ option.value }}</mat-option
        >
      </mat-select>
    </ng-template>
    <ng-template #multipleChoose>
      <mat-select
        disableRipple
        [formControl]="formControl"
        multiple
        [panelClass]="customStyle"
        tabIndex="0"
        disableOptionCentering
        [disabled]="disabled"
        (openedChange)="openChangeStatus($event)">
        <mat-option
          [ngClass]="currentCheckboxColor"
          class="dropdown-custom"
          *ngFor="let option of optionList"
          [value]="option.key"
          [attr.aria-label]="option.value"
          >{{ option.value }}</mat-option
        >
      </mat-select>
    </ng-template>
  </ng-template>
  <ng-template #templated>
    <div *ngIf="isMultiple; then multipleChoose; else singleChoose"></div>

    <ng-template #singleChoose>
      <mat-select
        disableRipple
        [(ngModel)]="model"
        [panelClass]="customStyle"
        tabIndex="0"
        (selectionChange)="changeValue($event)"
        disableOptionCentering
        [disabled]="disabled"
        [required]="required"
        (openedChange)="openChangeStatus($event)">
        <mat-option
          [ngClass]="currentCheckboxColor"
          class="dropdown-custom"
          *ngFor="let option of optionList"
          [value]="option.key"
          [attr.aria-label]="option.value"
          >{{ option.value }}</mat-option
        >
      </mat-select>
    </ng-template>
    <ng-template #multipleChoose>
      <mat-select
        disableRipple
        [(ngModel)]="model"
        multiple
        [panelClass]="customStyle"
        tabIndex="0"
        (selectionChange)="changeValue($event)"
        disableOptionCentering
        [disabled]="disabled"
        [required]="required"
        (openedChange)="openChangeStatus($event)">
        <mat-option
          [ngClass]="currentCheckboxColor"
          class="dropdown-custom"
          *ngFor="let option of optionList"
          [value]="option.key"
          [attr.aria-label]="option.value"
          >{{ option.value }}</mat-option
        >
      </mat-select>
    </ng-template>
  </ng-template>
</seds-form-field-core>
